import {UploadOutlined} from '@ant-design/icons';
import {Button, Flex, Upload, UploadProps} from 'antd';
import {RcFile} from 'antd/es/upload/interface';
import {toNumber} from 'lodash';
import React from 'react';

import {ApiQuery} from '../../../../gen/api';
import {useAdminDeletePalletOrderAttachmentMutation} from '../../../../gen/api/apis';
import {AdminPalletOrderAttachmentMetadata, AdminPalletOrderAttachments} from '../../../../gen/api/models';
import {useNotification} from '../../../../NotificationContext';
import {downloadBlobAsFile} from '../../../helpers/files';
import {EditAttachment} from './EditAttachment';

export interface AttachmentsProps {
    orderId: number;
    attachments: AdminPalletOrderAttachments[];
    onSuccess: () => void;
}

interface EditAttachment {
    id: number;
    metadata: AdminPalletOrderAttachmentMetadata;
}

export const Attachments = (props: AttachmentsProps) => {
    const [editAttachment, setEditAttachment] = React.useState<EditAttachment | null>(null);
    console.log('props.attachments', props.attachments);
    const notify = useNotification();
    const attach = ApiQuery.useAdminCreatePalletOrderAttachmentMutation({
        onSuccess() {
            notify.openNotificationWithIcon('success', 'Attachment added');
            props.onSuccess();
        },
        onError() {
            notify.openNotificationWithIcon('error', 'Failed to attach images');
        },
    });

    const download = ApiQuery.useAdminDownloadPalletOrderAttachmentMutation();

    const deleteAttachment = useAdminDeletePalletOrderAttachmentMutation({
        onSuccess() {
            notify.openNotificationWithIcon('success', 'Attachment deleted');
            props.onSuccess();
        },
        onError() {
            notify.openNotificationWithIcon('error', 'Failed to delete attachment');
        },
    });

    const uploadProps: UploadProps = {
        onChange({file, fileList}) {
            console.log(`onChange`, file, fileList);
            if (file.status !== 'uploading') {
                console.log(file, fileList);
            }
        },
        itemRender: (originNode, file, fileList, actions) => {
            if (file.status === 'uploading') {
                return originNode;
            }
            return (
                <Flex
                    align="center"
                    justify={'space-between'}
                    gap={8}
                    key={file.uid}
                >
                    {originNode}
                    <Button
                        type="link"
                        onClick={() => {
                            setEditAttachment({
                                id: toNumber(file.uid),
                                metadata: file.response.meta || {},
                            });
                        }}
                    >
                        Edit
                    </Button>
                </Flex>
            );
        },
        beforeUpload: (file: RcFile) => {
            attach.mutate({
                id: props.orderId,
                fileName: file.name,
                attachment: file,
            });
            return false;
        },
        onRemove: (file) => {
            deleteAttachment.mutate({
                id: props.orderId,
                attachmentId: toNumber(file.uid),
            });
            return false;
        },
        onDownload: (file) => {
            console.log('onDownload', file);
            download
                .mutateAsync({
                    id: props.orderId,
                    attachmentId: toNumber(file.uid),
                })
                .then((data) => {
                    downloadBlobAsFile(data, file.name);
                })
                .catch(() => {
                    notify.openNotificationWithIcon('error', 'Failed to download images');
                });
            return true;
        },
        defaultFileList: props.attachments.map((attachment) => ({
            ...attachment,
            uid: attachment.id.toString(),
            response: attachment,
            status: 'done',
        })),
        multiple: false,
        showUploadList: {
            showDownloadIcon: true,
            downloadIcon: 'Download',
            /*extra: (file) => (
                <span>
                    {file.name} ({file.size} bytes)
                </span>
            ),*/
            // showRemoveIcon: true,
        },
    };
    return (
        <>
            <Upload {...uploadProps}>
                <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>
            {editAttachment && (
                <EditAttachment
                    id={editAttachment.id}
                    metadata={editAttachment.metadata}
                    onSuccess={() => {
                        props.onSuccess();
                        setEditAttachment(null);
                    }}
                    onClosed={() => setEditAttachment(null)}
                />
            )}
        </>
    );
};
